import React, { SyntheticEvent, useContext, useEffect, useState } from "react";
import DropdownWithCheckboxMenu from "../../../../../../../components/DropdownWithCheckboxMenu";
import { PUBLIC_URL } from "../../../../../../App/configs/Constants";
import { useDispatch, useSelector } from "react-redux";
import { dashboardDayOfficeBookingFilterAction } from "../../../../../actions/DashboardActions";
import {
  PROPERTY,
  DAY_OFFICE_BOOKING_ALL_STATUS,
  DAY_OFFICE_BOOKING_CANCELLED_STATUS,
  DAY_OFFICE_BOOKING_COMPLETED_STATUS,
  DAY_OFFICE_BOOKING_CONFIRMED_STATUS,
  DAY_OFFICE_BOOKING_DECLINED_STATUS,
  DAY_OFFICE_BOOKING_NOT_REFUNDED_STATUS,
  DAY_OFFICE_BOOKING_PENDING_REFUNDED_STATUS,
  DAY_OFFICE_BOOKING_PENDING_STATUS,
  DAY_OFFICE_BOOKING_REFUND_FILTER,
  DAY_OFFICE_BOOKING_REFUNDED_STATUS,
} from "../../../../../configs/Constants";
import {
  dashboardFilterDateRangeSelector,
  dashboardPropertyChooseSelector,
  dashboardDayOfficeBookingFilterSelector,
} from "../../../../../selectors/DashboardSelectors";
import { LocalizationContext } from "../../../../../../../locales/Translation";
import {
  createDayOfficeBookingStatusFilterService,
  createRoomBookingStatusFilterService,
} from "../../../../../services/DashboardServices";
import { usePermissionCheck } from "../../../../../../../utils/custom-hooks";
import { UI_ACCESS_TRANSACTION_BY_FILTER_PER } from "../../../../../../../utils/PermissionConstant";

const FilterDayOfficeBooking = () => {
  const { translations } = useContext(LocalizationContext);

  const dispatch = useDispatch();
  const dashboardDayOfficeBookingFilter = useSelector(
    dashboardDayOfficeBookingFilterSelector
  );
  const dashboardFilterDateRange = useSelector(
    dashboardFilterDateRangeSelector
  );

  const [roomBookingStatus, setRoomBookingStatus] = useState<
    { id: string; name: string }[]
  >([]);

  const dashboardPropertyChoose = useSelector(dashboardPropertyChooseSelector);

  const propertyContext = usePermissionCheck(
    UI_ACCESS_TRANSACTION_BY_FILTER_PER
  );

  if (propertyContext) {
    useEffect(() => {
      (async () => {
        try {
          if (
            dashboardFilterDateRange === null ||
            dashboardPropertyChoose === null
          ) {
            return;
          }
          await createDayOfficeBookingStatusFilterService({
            translations,
            setStatus: setRoomBookingStatus,
            type: PROPERTY,
            propertyContext,
          });
        } catch (e) {
          console.log("e", e);
        }
      })();
    }, [
      dashboardDayOfficeBookingFilter?.keyword,
      dashboardFilterDateRange,
      dashboardPropertyChoose,
    ]);
  } else {
    useEffect(() => {
      (async () => {
        try {
          if (dashboardFilterDateRange === null) {
            return;
          }
          await createRoomBookingStatusFilterService({
            translations,
            setStatus: setRoomBookingStatus,
            type: PROPERTY,
            propertyContext,
          });
        } catch (e) {
          console.log("e", e);
        }
      })();
    }, [dashboardDayOfficeBookingFilter?.keyword, dashboardFilterDateRange]);
  }

  const _onChangeFilter = (e: SyntheticEvent, data: any) => {
    if (data.value === DAY_OFFICE_BOOKING_ALL_STATUS) {
      if (data.checked) {
        dispatch(
          dashboardDayOfficeBookingFilterAction({
            key: "filter_status",
            value: [
              DAY_OFFICE_BOOKING_ALL_STATUS,
              DAY_OFFICE_BOOKING_CONFIRMED_STATUS,
              DAY_OFFICE_BOOKING_PENDING_STATUS,
              DAY_OFFICE_BOOKING_DECLINED_STATUS,
              DAY_OFFICE_BOOKING_CANCELLED_STATUS,
              DAY_OFFICE_BOOKING_COMPLETED_STATUS,
            ],
          })
        );
        dispatch(
          dashboardDayOfficeBookingFilterAction({
            key: "filter_refund_status",
            value: [
              DAY_OFFICE_BOOKING_PENDING_REFUNDED_STATUS,
              DAY_OFFICE_BOOKING_REFUNDED_STATUS,
              DAY_OFFICE_BOOKING_NOT_REFUNDED_STATUS,
            ],
          })
        );
      } else {
        dispatch(
          dashboardDayOfficeBookingFilterAction({
            key: "filter_status",
            value: [],
          })
        );
        dispatch(
          dashboardDayOfficeBookingFilterAction({
            key: "filter_refund_status",
            value: [],
          })
        );
      }
      return;
    }

    if (data.checked) {
      if (DAY_OFFICE_BOOKING_REFUND_FILTER.includes(data.value)) {
        const newValue = [
          ...dashboardDayOfficeBookingFilter.filter_refund_status,
          data.value,
        ];
        dispatch(
          dashboardDayOfficeBookingFilterAction({
            key: "filter_refund_status",
            value: newValue,
          })
        );
      } else {
        const newValue = [
          ...dashboardDayOfficeBookingFilter.filter_status,
          data.value,
        ];
        dispatch(
          dashboardDayOfficeBookingFilterAction({
            key: "filter_status",
            value: newValue,
          })
        );
      }
      return;
    }

    if (DAY_OFFICE_BOOKING_REFUND_FILTER.includes(data.value)) {
      const newValue =
        dashboardDayOfficeBookingFilter.filter_refund_status.filter(
          (status: string) =>
            status !== data.value && status !== DAY_OFFICE_BOOKING_ALL_STATUS
        );
      dispatch(
        dashboardDayOfficeBookingFilterAction({
          key: "filter_refund_status",
          value: newValue,
        })
      );
    } else {
      const newValue = dashboardDayOfficeBookingFilter.filter_status.filter(
        (status: string) =>
          status !== data.value && status !== DAY_OFFICE_BOOKING_ALL_STATUS
      );
      dispatch(
        dashboardDayOfficeBookingFilterAction({
          key: "filter_status",
          value: newValue,
        })
      );
    }
  };

  return (
    <div className={"dropdown-filter"}>
      <DropdownWithCheckboxMenu
        onChange={_onChangeFilter}
        listCheckBox={roomBookingStatus.map((filter: any) => {
          if (DAY_OFFICE_BOOKING_REFUND_FILTER.includes(filter.id)) {
            if (
              dashboardDayOfficeBookingFilter.filter_refund_status.includes(
                filter.id
              )
            ) {
              filter.checked = true;
            } else {
              filter.checked = false;
            }

            return filter;
          }

          if (
            dashboardDayOfficeBookingFilter.filter_status.includes(filter.id)
          ) {
            filter.checked = true;
          } else {
            filter.checked = false;
          }

          return filter;
        })}
        label={translations.filters}
        icon={
          <img
            alt={"Deskimo"}
            src={PUBLIC_URL + "/assets/icons/icon-filter.svg"}
          />
        }
      />
    </div>
  );
};

export default FilterDayOfficeBooking;
